import React, {useEffect} from 'react';
import {message} from 'antd';

import {AppLoader} from '../../../@crema';
import {useDispatch, useSelector} from 'react-redux';
import {hideMessage} from '../../../redux/actions';

const AppInfoView = () => {
  const {loading, error, displayMessage, loaderMessage} = useSelector(
    ({common}) => common,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      message.error({
        content: typeof error === 'string' ? error : String(error),
        duration: 6,
        style: {marginTop: 24},
      });
      dispatch(hideMessage());
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (displayMessage !== undefined && displayMessage !== '') {
      message.success(displayMessage);
      dispatch(hideMessage());
    }
  }, [displayMessage]);

  return <>{loading ? <AppLoader message={loaderMessage || 'Please wait…'} /> : null}</>;
};

export default AppInfoView;
